import { STATUS_LABELS, STATUS_TONE } from "@/lib/api";

export function StatusBadge({ status }) {
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${STATUS_TONE[status] || "bg-cyan-50 text-cyan-800 border-cyan-200"}`}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}
